import type { PostSigninRequest } from './types';
import type { GetSigninResponse } from '../get';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postSignin = async ({ data, lang, token }: PostGenericEndpointParams<PostSigninRequest>): Promise<GetSigninResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'signin',
    });
};
